module.exports = __webpack_public_path__ + "img/appkaifa.f2433cb1.png";